// extracted by mini-css-extract-plugin
export default {"Dialog":"📚19-10-2ejzGH"};